// extracted by mini-css-extract-plugin
module.exports = {"terms":"views_terms__2nPAQ"};